import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Requisito no negociable del proyecto: conectividad de campo intermitente
// (Starlink), por eso se registra el service worker (offline-first real),
// a diferencia del unregister() que trae la plantilla CRA por defecto.
// onUpdate dispara un evento que escucha <ActualizacionDisponible /> (ver
// MainLayout.js) para mostrar el banner de "hay una versión nueva".
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent("nueva-version-disponible", { detail: registration }));
  },
});

reportWebVitals();
